import React from 'react'
import { UserLayout } from '../Layout/UserLayout'
import { Breadcrumb } from "../component/Breadcrumb";
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useQuery } from '../helper/Query';
import { useState } from 'react';
import { useEffect } from 'react';
import cinstance from '../api/axios';
import { PrimaryButton } from '../component/Atom/form-field';
import { useNavigate, useParams } from 'react-router-dom';
import { Seo } from '../component/Seo';
import { buildMemberSeo, hasPublicProfile, SITE } from '../helper/Static data/seo';
import { findBySlug, teamPath, teamSlug } from '../helper/slug';


const ClientOurTeamView = () => {


  const [singlemember, setSingleMember] = useState()
  const [notFound, setNotFound] = useState(false)

  const language_web = useSelector((state) => state.webLanguage.value)
  const query = useQuery();
  const { slug } = useParams();
  const legacyId = query.get("team_id");

  let navigate = useNavigate();

  // There is no slug column in Mongo, so the record is resolved by matching the
  // slug against the full team list rather than fetched by id.
  useEffect(() => {
    let cancelled = false;
    setNotFound(false);

    (async () => {
      try {
        const res = await cinstance({ url: `/ourteams/get-all-teams`, method: "GET" });
        if (cancelled) return;
        const teams = Array.isArray(res.data) ? res.data : [];

        // Old ?team_id= link — send it on to the slug URL and keep the id out
        // of history so back does not bounce between the two forms.
        if (legacyId) {
          const byId = teams.find((t) => t?._id === legacyId);
          if (byId) {
            navigate(teamPath(byId), { replace: true });
            return;
          }
        }

        const match = findBySlug(teams, slug, teamSlug);
        if (match) setSingleMember(match);
        else setNotFound(true);
      } catch (e) {
        console.error(e);
        if (!cancelled) setNotFound(true);
      }
    })();

    return () => { cancelled = true; };
  }, [slug, legacyId, navigate]);


  const desc = singlemember?.[language_web]?.desc

  const memberName = singlemember?.[language_web]?.name || singlemember?.en?.name
  const memberSeo = buildMemberSeo(singlemember, language_web)
  const memberJsonLd = memberName
    ? {
      "@context": "https://schema.org",
      "@type": "Person",
      name: memberName,
      jobTitle: singlemember?.[language_web]?.position,
      image: singlemember?.img,
      url: `${SITE.url}${teamPath(singlemember)}`,
      worksFor: {
        "@type": "LegalService",
        name: "Bin Haider Advocates & Legal Consultants",
        url: SITE.url,
      },
    }
    : undefined

  return (
    <UserLayout>
      <Seo
        title={memberSeo.title}
        description={memberSeo.description}
        image={singlemember?.img}
        imageAlt={memberName}
        path={singlemember ? teamPath(singlemember) : undefined}
        type="profile"
        noindex={notFound || (!!singlemember && !hasPublicProfile(singlemember))}
        jsonLd={memberJsonLd}
      />
      <Breadcrumb image={"ourteam-banner"}  />
      {/* label={language_web === "ARE" ?("فريقنا"): ("Our Team")} */}

      <div className='container mx-auto sm:py-4  xl:py-[70px]'>
        {notFound ? (
          <div className='text-white-wind text-center py-20'>
            <h1 className='font-semibold text-2xl pb-4'>
              {language_web === "ARE" ? ("لم يتم العثور على عضو الفريق") : ("Team member not found")}
            </h1>
            <button onClick={() => navigate("/our-team")} className="bg-primary-wind px-3 py-2 text-white text-sm font-light">
              {language_web === "ARE" ? ("العودة إلى فريقنا") : ("Back To Our Team")}
            </button>
          </div>
        ) : (
        <div>
          <div className='grid grid-cols-1 xl:grid-cols-2 justify-items-center xl:justify-items-start'>
            <img src={singlemember?.img} alt={memberName ? `${memberName} — ${singlemember?.[language_web]?.position || "Bin Haider Advocates & Legal Consultants"}` : "Bin Haider Advocates & Legal Consultants"} className='h-[450px] sm:h-[570px] object-contain' />
              <div className='h-auto sm:pt-4 xl:pt-0  text-white-wind'>
              <div className='grid'>
                <h1 className='font-semibold text-lg text-start '>{singlemember?.[language_web]?.name}</h1>
                <div className='pt-2'><span className='font-normal text-sm'> {language_web === "ARE" ?("تعيين"):("Designation")}:  </span>
                  <span className='text-[14px] leading-[24px] font-extralight'>{singlemember?.[language_web]?.position}</span> </div>
                <div className='pt-2' > <span className='font-normal text-sm'> {language_web === "ARE" ?("خبرة"):("Experience")}: </span>
                  <span className='text-[14px] leading-[24px] font-extralight'>{singlemember?.experienceyear}+</span></div>
              </div>
              <div>
                <h2 className='font-semibold text-2xl py-4'> {language_web === "ARE" ?("ملخص"):("Summary")}</h2>
                <p className='font-extralight text-[14px] leading-[24px] text-start fake-class' dangerouslySetInnerHTML={{ __html: desc }} />
              </div>
              {/***back Button */}
              <div className='py-6'>
                <button onClick={() => navigate("/our-team")} className="bg-primary-wind  px-3 py-2 text-white text-sm font-light">
                {language_web === "ARE" ?("العودة إلى فريقنا"):("Back To Our Team")} 
                </button>
              </div>
            </div>

          </div>
        </div>
        )}
      </div>

    </UserLayout>
  )
}

export default ClientOurTeamView